import type { core } from 'zod';
import { en, fa } from 'zod/locales';
import { getLocale } from './browser';

const maps = { en: en().localeError, fa: fa().localeError };
/** Per-parse error map; never changes Zod's process-wide configuration. */
export const validationError: core.$ZodErrorMap = (issue) => maps[getLocale()](issue);
